import { render, staticRenderFns } from "./template-action.vue?vue&type=template&id=dcb7651e&"
import script from "./template-action.vue?vue&type=script&lang=js&"
export * from "./template-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports